var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"vehicle-thumbnail",style:({ 'background-image': `url('${_vm.src}')` })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }